export const eventActionTypes={
    GET_ALL_EVENTS_START: 'GET_ALL_EVENTS',
    GET_ALL_EVENTS_SUCCESS: 'GET_ALL_EVENTS_SUCCESS',
    GET_ALL_EVENTS_FAILURE: 'GET_ALL_EVENTS_FAILURE',
}